import { Card, CardContent } from '@/components/ui/card';
import { CardHeader } from '../CardHeader';
import { UnplayedCardItem } from './UnplayedCardItem';
// import moneymint from "@/assets/moneymint.png";
// import millionairemaker from "@/assets/MillionaireMaker.png";
// import type { GameThemeId } from '@skillscratch/shared-types';
// import { useFirebaseFunction } from '@/hooks/useFirebaseFunction';
import { useEffect } from 'react';
import { CircularLoadingSpinner } from '../CircularLoadingSpinner/CircularLoadingSpinner';
import { useModal } from '@/hooks/useModal';
import { ErrorModal } from '../Modals/ErrorModal';
import { UserGamePack } from '@skillscratch/shared-types';
// export type UnplayedCard = {
//     name: string;
//     count: number;
//     src: string;
//     borderColor: string;
//     id: string;
//     gameThemeId: GameThemeId;
//   };

export function UnplayedCards({ userGamePacks, isUserGamePacksLoading, userGamePacksError}: 
    { userGamePacks: UserGamePack[] | undefined, isUserGamePacksLoading: boolean, userGamePacksError: Error | undefined }) {


    const { openModal } = useModal();

     // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
     useEffect(() => {
        if (userGamePacksError) {
            openModal(<ErrorModal message={userGamePacksError.message}/>);
        }
     // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [userGamePacksError]);

    const filterSkyCards = userGamePacks?.filter((unplayedCard) => unplayedCard.gameThemeId !== 'sky-card');
    // const filteredUserGamePacks = filterSkyCards?.filter((unplayedCard) => unplayedCard.count - unplayedCard.usedCount + 1 > 0);


    if (!filterSkyCards?.length) {
        return null;
    }

    return (
        <Card className="max-w-md rounded-lg overflow-hidden shadow-md bg-white border-0" id='unplayedcard-card'>
            <CardHeader title="Unplayed Cards" />
                <CardContent className="p-0">
                    {/* Prize Cards */}
                    {!isUserGamePacksLoading ?
                    <div className='my-2'>
                        {filterSkyCards?.map((unplayedCard) => (
                            <UnplayedCardItem key={unplayedCard.id} unplayedCard={unplayedCard} />
                        ))}
                    </div> : 
                        <div className="flex items-center p-2 m-2 my-3 mx-3.5 border rounded-md border-blue-sky z-20 relative justify-center">
                            <CircularLoadingSpinner />
                        </div>}
                </CardContent> 
            
        </Card>
    );
}